import { __open_fullscreen, __close_fullscreen } from './functions';
/*
 * Menu functionality
 */

export let __trigger_small_menu_active_by_id = async function (id) {
    let anchor_selector = '.js--section-item-link';

    for (let anchor of Array.from($(anchor_selector))) {
        $(anchor).removeClass('active');
    }

    let current_anchor = $(anchor_selector + '[data-elementor-id="' + id + '"]');

    if (current_anchor.length > 0) {
        $(current_anchor).addClass('active');
    }
};

export let __small_nav_section_anchor = function (settings) {
    let anchor_selector = '.js--section-item-link';

    for (let anchor of Array.from($(anchor_selector))) {
        $(anchor).off('click');
        $(anchor).on('click', async function (event) {
            $(this).addClass('active');
            let index = $(this).attr('data-index');
            let anchor_url = $(this).attr('data-menuanchor');
            let elementor_section_id = $(this).attr('data-elementor-id');

            $(anchor_selector + ':not([data-index="' + index + '"])').each(async function (element_index, element) {
                $(element).removeClass('active');
            });

            event.preventDefault();

            await settings.__set_autoscroll(true);
            $('html, body')
                .stop()
                .animate(
                    { scrollTop: $('.elementor-section[data-id="' + elementor_section_id + '"]').offset().top },
                    800
                );
            setTimeout(async function () {
                await settings.__set_autoscroll(false);
            }, 805);
        });
    }
};

let __toggle_expand_left_menu = async function () {
    let menu_selector = '.stmnt--menu';
    let left_menu_side = $(menu_selector).find('.left--side');
    let middle_menu_side = $(menu_selector).find('.middle--side');

    if (!$(left_menu_side).hasClass('expand')) {
        $(left_menu_side).addClass('expand');
    } else {
        $(left_menu_side).removeClass('expand');
    }

    if (!$(middle_menu_side).hasClass('expand')) {
        $(middle_menu_side).addClass('expand');
    } else {
        $(middle_menu_side).removeClass('expand');
    }
};

export let __toggle_menu = function () {
    let menu_toggle_button = $('.js--menu-toggle-button');
    let menu_hamburger_toggle = $('.js--hamburger-toggle');

    let main_menu = $(menu_toggle_button).parent();

    $(menu_toggle_button).on('click', async function (event) {
        // Event prevent default
        event.preventDefault();

        // Toggle the menu
        $(menu_hamburger_toggle).toggleClass('open');
        await __toggle_expand_left_menu();
        $(main_menu).toggleClass('active');
    });
};

export let __handle_meta_menu_item = function (GLOBAL_SETTINGS) {
    let meta_menu_item_selector = '.js--meta-menu-item';

    $(meta_menu_item_selector)
        .find('.js--action-button')
        .on('click', async function (event) {
            // Event prevent default
            event.preventDefault();

            let type = $(this).attr('data-type');

            if (type == 'action') {
                let action = $(this).attr('data-action');
                if (action == 'fullscreen') {
                    let is_fullscreen = await GLOBAL_SETTINGS.__get_fullscreen();
                    if (!is_fullscreen) {
                        __open_fullscreen();
                        $(this).addClass('active');
                        await GLOBAL_SETTINGS.__set_fullscreen(true);
                    } else {
                        __close_fullscreen();
                        $(this).removeClass('active');
                        await GLOBAL_SETTINGS.__set_fullscreen(false);
                    }
                } else if (action == 'volume') {
                }
            }
            else if(type == 'link') {
                window.open($(this).attr('data-link'), '_blank');
            }
        });

    $(meta_menu_item_selector)
        .find('a')
        .on('click', async function (event) {
            // Event prevent default
            event.preventDefault();

            let type = $(this).attr('data-type');

            if(type == 'link') {
                window.open($(this).attr('data-link'), '_blank');
            }
        });

};
